import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ArrowRightIcon } from '@components/common/Icons/ArrowRightIcon';
import { CalculatorSubmitButtonProps } from './types';

export const CalculatorSubmitButton: FC<CalculatorSubmitButtonProps> = ({
  onClick = () => undefined,
  textKey = 'common.saveContinue',
  buttonType = 'button',
  isLoading = false,
  circularProgressProps,
  circularProgressClassName,
}) => (
  <Button
    htmlType={buttonType}
    onClick={onClick}
    disabled={isLoading}
    shape={'round'}
    className={
      'font-satoshi-black bg-main! hover:bg-main! disabled:bg-main! m-0 inline-flex! h-auto! items-center! justify-center! border-none px-12! py-[0.8rem]! text-base leading-none! text-white! shadow-none hover:text-white! disabled:text-white!'
    }
  >
    {isLoading ? (
      <span className={`inline-flex items-center justify-center leading-none ${circularProgressClassName ?? ''}`}>
        <Spin
          indicator={
            <LoadingOutlined
              style={{ fontSize: circularProgressProps?.size ?? 28, color: circularProgressProps?.color ?? 'inherit' }}
              spin
            />
          }
        />
      </span>
    ) : (
      <span className={'inline-flex items-center justify-center leading-none'}>
        <FormattedMessage id={textKey} />
        <ArrowRightIcon className={'ml-[0.8rem] block shrink-0'} />
      </span>
    )}
  </Button>
);
